/** Injectable clock so time-dependent logic stays deterministic in tests. */
export interface Clock {
  nowIso(): string;
}

export const systemClock: Clock = {
  nowIso: () => new Date().toISOString(),
};

/** A clock that returns a fixed, then optionally advancing, timestamp. */
export function fixedClock(start = '2026-01-01T00:00:00.000Z'): Clock & { advance(ms: number): void } {
  let current = new Date(start).getTime();
  return {
    nowIso: () => new Date(current).toISOString(),
    advance: (ms: number) => {
      current += ms;
    },
  };
}
